export default __webpack_public_path__ + "static/media/popo.8f6a4b29.jpeg";